import { X } from 'lucide-react';
import { cn } from 'utils/classnames';
import { useAppStore, useProductStore } from 'store';
import { SCREEN_TYPES } from 'utils/constants';
import { getCurrentColors } from 'utils/getCurrentColor';

const Detail = ({ label, value }: { label: string; value?: string | number | null }) => {
  if (value == null || value === '') return null;
  return (
    <span className="text-slate-500">
      {label}: <span className="font-semibold text-slate-800">{value}</span>
    </span>
  );
};

export function GradingDispositionSheet() {
  const { currentScreen } = useAppStore();
  const { currentProduct, showGradingSheet, setShowGradingSheet } = useProductStore();

  const visible =
    currentScreen === SCREEN_TYPES.SCAN_BOX &&
    showGradingSheet &&
    (currentProduct?.disposition_stage || currentProduct?.receipt_grade);

  if (!visible) return null;

  const stage = currentProduct?.disposition_stage || currentProduct?.receipt_grade || '';
  const { sheet, badge } = getCurrentColors(stage);
  const isUnknown = currentProduct?.product_id === 'Unknown';

  return (
    <div className={cn('border-t px-4 py-5 animate-in slide-in-from-bottom duration-200', sheet)}>
      <div className="flex items-center gap-3 mb-4">
        <span className="text-xs font-bold uppercase tracking-wide text-slate-500 shrink-0">
          Move To
        </span>
        <span
          className={cn(
            'inline-flex rounded-full border px-3 py-1 text-sm font-bold uppercase tracking-wide',
            badge
          )}
        >
          {stage}
        </span>
        <button
          type="button"
          onClick={() => setShowGradingSheet(false)}
          className="ml-auto shrink-0 rounded-full p-1 text-slate-400 hover:bg-white/60 hover:text-slate-600 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="space-y-1.5">
        {currentProduct?.description && (
          <div className="text-sm font-semibold text-slate-900">{currentProduct.description}</div>
        )}
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs">
          {!isUnknown && <Detail label="Article" value={currentProduct?.product_id} />}
          <Detail label="UPC" value={currentProduct?.upc} />
          <Detail label="Color" value={currentProduct?.style_color} />
          <Detail label="Color Name" value={currentProduct?.style_color_name} />
          <Detail label="Size" value={currentProduct?.product_size} />
        </div>
      </div>
    </div>
  );
}
